export enum permissionEnums {
	CONTENT_VIEW = 'content_view',
	CONTENT_EDIT = 'content_edit',
	MENU_INCOMING_CLIENT = 'menu_incoming_clients',
	ADD_NEW_ACCOUNT = 'add_new_account',
	IN_PROGRESS_ACCOUNTS = 'in_progress_accounts',
	MENU_MANAGE_CLIENTS_ACTIVITY = 'menu_manage_clients_activity',
	CLIENTS_ACTIVITY_DASHBOARD = 'clients_activity_dashboard',
	FREE_TEXT_SEARCH_DATABASE = 'free_text_search_data_base',
	HOUSE_ACCOUNT_BALANCE = 'house_account_balance',
	DASHBOARD_PENDING_REQUESTS_ANALYTICS = 'get_analytics_pending_requests',
	BO_SIGNER_DASHBOARD_REQUESTS = 'bo_signer_dashboard_requests',
	CLIENTS_ACTIVITY_DASHBOARD_SIGNER = 'clients_activity_dashboard_signer',
	CUSTOMER_ACCOUNTS = 'customer_accounts',
	CLIENTS_ACTIVITY_PENDING_REQUESTS = 'clients_activity_pending_requests',
	CLIENTS_ACTIVITY_REPORTS = 'clients_activity_reports',
	MENU_SYSTEM_MANAGEMENT = 'menu_system_management',
	OPEN_PAGES_CONTENT = 'open_pages_content',
	NOTIFICATIONS_CONTENT = 'notifications_content',
	EMAIL_CONTENT = 'email_content',
	ERRORS_CONTENT = 'errors_content',
	BUSINESS_MODEL_CONTENT = 'business_model_content',
	BUSINESS_MODEL_PLAN_EDITOR = 'business_model_plan_editor',
	BUSINESS_MODEL_COINS_COUPLES_EDITOR = 'business_model_coins_couples_editor',
	MENU_MARKETING_MANAGEMENT = 'menu_marketing_management',
	MENU_SYSTEM_MESSAGES = 'menu_system_messages',
	VIEW_SYSTEM_MESSAGES = 'view_system_messages',
	CREATE_SYSTEM_MESSAGE = 'create_system_message',
	DISABLE_SYSTEM_MESSAGE = 'disable_system_message',
	VIEW_SYSTEM_MESSAGES_COMPANY = 'view_system_messages_company',
	CREATE_SYSTEM_MESSAGE_COMPANY = 'create_system_message_company',
	HOME_ARTICLES_CONTENT = 'home_articles_content',
	WELCOME_SCREEN_CONTENT = 'welcome_screen_content',
	MARKETING_EDITOR = 'marketing_editor',
	TERMS_AMD_CONDITIONS_CONTENT = 'terms_and_conditions_content',
	CLIENTS_ACTIVITY_BENEFICIARIES_REPORT = 'clients_activity_beneficiaries_report',
	CLIENTS_ACTIVITY_COMPANIES_REPORT = 'clients_activity_companies_report',
	CLIENTS_ACTIVITY_TRANSACTIONS_REPORT = 'clients_activity_transactions_report',
	CLIENTS_ACTIVITY_BALANCES_REPORT = 'clients_activity_balances_report',
	GET_ALL_PENDING_REQUESTS = 'get_all_pending_requests',
	GET_ANALYTICS_PENDING_REQUESTS = 'get_analytics_pending_requests',
	APPROVE_BALANCE = 'approve_balance',
	APPROVE_WITHDRAWAL = 'approve_withdrawal',
	APPROVE_SUPPORT_REQUEST = 'approve_support_request',
	APPROVE_BENEFICIARY = 'approve_beneficiary',
	APPROVE_PAYMENT = 'approve_payment',
	APPROVE_ACCOUNT = 'approve_account',
	RESEND_WELCOME_EMAIL = 'resend_welcome_email',
	APPROVE_BANK_ACCOUNT = 'approve_bank_account',
	REMOVAL_ACCOUNT = 'remove_account',
	UPSERT_ACCOUNT = 'upsert_account',
	UPSERT_BANK_ACCOUNT = 'upsert_bank_account',
	UPSERT_NEW_USER = 'upsert_new_user',
	EDIT_COMPANY = 'edit_company',
	EDIT_CONTACT = 'edit_contact',
	EDIT_BANK_ACCOUNT = 'edit_bank_account',
	EDIT_BENEFICIARY = 'edit_beneficiary',
	EDIT_CONTACT_STATUS = 'edit_contact_status',
	EDIT_BANK_ACCOUNT_STATUS = 'edit_bank_account_status',
	EDIT_BENEFICIARY_STATUS = 'edit_beneficiary_status',
	EDIT_PAYMENT_STATUS = 'edit_payment_status',
	READ_ACCOUNT = 'read_account',
	GET_NEW_USERS = 'get_new_users',
	GET_NEW_BANK_ACCOUNTS = 'get_new_bank_accounts',
	EDIT_COUNTRIES = 'edit_countries',
	EDIT_CUSTOMER_RELATIONS = 'edit_customer_relations',
	EDIT_PAYMENTS_PURPOSE = 'edit_payments_purpose',
	MENU_DASHBOARD = 'menu_dashboard',
	DASHBOARD_BALANCES = 'dashboard_balances',
	DASHBOARD_ACCOUNT_BALANCE = 'dashboard_account_balance',
	DASHBOARD_PENDING_BALANCE = 'dashboard_pending_balance',
	DASHBOARD_CONVERSION_FEES = 'dashboard_conversion_fees',
	DASHBOARD_PAYMENT_FEES = 'dashboard_payment_fees',
	DASHBOARD_PLANS_FEES = 'dashboard_plans_fees',
	VIEW_BENEFIT = 'view_benefit',
	CREATE_BENEFIT = 'create_benefit',
	ASSIGN_COMPANY_BENEFIT = 'assign_company_benefit',
	BO_SIGNER_CREATE_REFUND = 'bo_signer_create_refund',
	CLIENTS_ACTIVITY_REFUNDS_REPORT = 'clients_activity_refunds_report',
	CLIENTS_ACTIVITY_PAYMENT_FEES_REPORT = 'clients_activity_payment_fees_report',
	CLIENTS_ACTIVITY_CONVERSION_FEES_REPORT = 'clients_activity_conversion_fees_report',
	CLIENTS_ACTIVITY_ACCOUNT_ACTIVITIES_REPORT = 'clients_activity_account_activities_report',
	EDIT_SYSTEM_SETTINGS = 'edit_system_settings',
	VIEW_PAYMENT_CATEGORIES = 'view_payment_categories',
	EDIT_PAYMENT_CATEGORIES = 'edit_payment_categories',
	MENU_WEBHOOK_MONITORING = 'menu_webhook_monitoring',
	VIEW_WEBHOOK_MONITORING = 'view_webhook_monitoring',
	REPLAY_WEBHOOK_OPERATION = 'replay_webhook_operation',
	VIEW_HYPER_MONITORING = 'view_hyper_monitoring',
	REPLAY_HYPER_OPERATION = 'replay_hyper_operation',
	READ_BENEFICIARY = 'read_beneficiary',
}
